import React from "react";
import styles from "./style.module.scss";
import Button from "@components/shared/form/button";
import MainLogo from "./logo";
import useWindowSize from "@hooks/useWindowSize";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
const Introduction = () => {
    const windowSize = useWindowSize();
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <section className={`${styles["mainContainer"]}`}>
            <div className=" flex flex-col lg:flex-row justify-between pt-20">
                <div className=" w-fit lg:w-auto mx-auto ">
                    <h2 className="lg:mt-32 font-extrabold  lg:text-5xl text-3xl lg:leading-[62px] leading-10 text-center lg:text-start px-5">
                        {translate(
                            translations,
                            "several_partnerWithUsPage_mainTitle",
                        )}
                    </h2>
                    <p className="max-w-lg font-medium text-sm leading-7 mt-5 text-center lg:text-start px-5">
                        {translate(
                            translations,
                            "several_partnerWithUsPage_mainDescription",
                        )}
                    </p>
                    <div className="max-w-[245px] mt-8 mx-auto lg:ms-4">
                        <Button
                            onClick={() => {
                                window.scroll({
                                    top:
                                        windowSize.width < 1024
                                            ? windowSize.width < 1024 &&
                                              windowSize.width > 450
                                                ? 3100
                                                : 3200
                                            : 1800,
                                    left: 0,
                                    behavior: "smooth",
                                });
                            }}
                            className="font-bold lg:text-lg text-base leading-9 lg:py-3 py-2"
                        >
                            {translate(
                                translations,
                                "several_partnerWithUsPage_letsTalk",
                            )}
                        </Button>
                    </div>
                </div>
                <div className=" relative lg:w-[514px] lg:h-[510px] lg:top-14 top-7 w-fit mx-auto">
                    <MainLogo />
                </div>
            </div>
        </section>
    );
};

export default Introduction;
